import { Component, OnInit } from '@angular/core';
import * as utils from '../../util';

@Component({
    selector: 'app-health',
    templateUrl: './health.container.html',
    standalone: false
})
export class HealthContainerComponent implements OnInit {
	public showMenu: boolean;
	public isSafari = false;

	ngOnInit(): void {
		this.isSafari = utils.isSafari();
	}
}
